import qs from 'qs';

export type CalculatorQueryProperty = 'house' | 'townhouse' | 'apartment' | 'unit';
export type CalculatorQueryUsage = 0.2 | 0.4 | 0.6 | 0.8;
export type CalculatorQuerySystemSize = 2.64 | 3.96 | 5.28 | 6.6 | 7.92;

export interface CalculatorQueryData {
  postcode?: number;
  mostUsage?: CalculatorQueryUsage;
  bill?: number;
}

export const createCalculatorObjectFromQueryString = (
  postcode?: string,
  mostUsage?: string,
  bill?: number,
  url: string = window.location.search
): CalculatorQueryData | false => {
  if (!url) return false;

  let query = url;
  if (url.startsWith('?')) query = url.slice(1);

  const data = qs.parse(query);
  const parsed: CalculatorQueryData = {};

  if (postcode || data.postcode) {
    parsed.postcode = postcode || data.postcode;
  }
  if (data.mostUsage) {
    parsed.mostUsage = parseFloat(mostUsage || data.mostUsage) as CalculatorQueryUsage;
  }
  if (data.bill) {
    parsed.bill = parseFloat(bill || data.bill) || 0;
  }

  return parsed;
};

export const createObjectFromQueryString = () =>
  document.location.search
    .slice(1)
    .split('&')
    .reduce((_qs, entry) => {
      const [key, value] = entry.split('=');
      _qs[key] = value;
      return _qs;
    }, {});
